<template>
  <div class="form-group">
    <button class="btn btn-success" @click="exportExcel">Export Excel</button>
  </div>
</template>
<script>
import { HTTPExport } from '../lib/httplib';
export default {
  props: ['url'],
  methods: {
    exportExcel () {
      HTTPExport.get(this.url).then((res) => {
        const data = res.data.data;
        window.open(data, '_blank');
      });
    }
  }
}
</script>